<template>
    <span
        :class="[
            $style.tag,
            props.type === 'Template' && $style.template_tag,
            props.type === 'Ideas' && $style.ideas_tag,
            props.size === 'medium' && $style.medium
        ]"
    >
        {{
            props.type === 'Template'
                ? $t('experience.onboarding.template')
                : $t('experience.onboarding.ideas')
        }}
    </span>
</template>

<script lang="ts">
export default {
    name: 'TemplateTag'
};
</script>

<script lang="ts" setup>
// interface
interface Props {
    type: 'Template' | 'Ideas';
    size?: 'medium';
}
// props
const props = defineProps<Props>();
</script>

<style lang="scss" module>
@import '@style/import.scss';
.tag {
    font-size: 12px;
    border-radius: 3px;
    padding: 0 2px;
    border: 1px solid $pt-info;
    line-height: 16px;
    &.medium {
        padding: 2px 8px;
    }
}
.template_tag {
    color: $pt-info;
    background-color: rgba(41, 182, 246, 0.2);
}
.ideas_tag {
    color: #7d5c00;
    background-color: #ffe18c;
    border-color: #ffc600;
}
</style>